import script from "./verrorUser.vue?vue&type=script&setup=true&lang=js"
export * from "./verrorUser.vue?vue&type=script&setup=true&lang=js"

import "./verrorUser.vue?vue&type=style&index=0&id=06b2f7e0&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06b2f7e0"]])

export default __exports__